import Image      from "_components/atoms/image";
import Typography from "_components/atoms/typography";
import useStyles  from "./styles";

const Component = ( { emptyText } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { classes.notificationTabEmptyViewContainer }>
			<div className = { classes.content }>
				<Image
					className = { classes.svgIcon }
					src = "/icons/TypeBell.webp"
				/>

				<Typography
					className = { classes.notificationEmptyText }
					color = "secondary"
					title = { emptyText }
					variant = "body1"
				/>
			</div>
		</div>
	);
};

export default Component;
